import { render, staticRenderFns } from "./mv-wd-gallary.vue?vue&type=template&id=db577238"
import script from "./mv-wd-gallary.vue?vue&type=script&lang=js"
export * from "./mv-wd-gallary.vue?vue&type=script&lang=js"
import style0 from "./mv-wd-gallary.vue?vue&type=style&index=0&id=db577238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports